import { INCIDENT_FIELDS } from './constants';
import IncidentAutocomplete from './IncidentAutocomplete';
import ApiAutocomplete from './ApiAutocomplete';
import React, { memo, useMemo } from 'react';
import ApiAutocompleteByEndpoint from '../../../ApiAutocomplete/ApiAutocompleteByEndpoint';
import AutocompleteByOptions from './AutocompleteByOptions';

const AutocompleteFactory = ({
  item,
  field,
  multiple,
  readonly,
  disabledStyles,
  incident,
  dependentFields,
}) => {
  const value = useMemo(() => {
    return multiple ? field.value || [] : field.value || '';
  }, [multiple, field.value]);

  const extraParams = useMemo(() => {
    return {
      incident_id: incident.id,
      ...dependentFields,
    };
  }, [dependentFields, incident.id]);

  if (Object.values(INCIDENT_FIELDS).includes(item.key)) {
    return (
      <IncidentAutocomplete
        id={field.name}
        onChange={field.onChange}
        multiple={multiple}
        size="small"
        inputRef={field.ref}
        value={value}
        disabled={readonly}
        sx={readonly ? disabledStyles : {}}
      />
    );
  }

  if (item.enum) {
    return (
      <ApiAutocomplete
        id={field.name}
        enumClass={item.enum}
        onChange={field.onChange}
        multiple={multiple}
        size="small"
        inputRef={field.ref}
        value={value}
        disabled={readonly}
        sx={readonly ? disabledStyles : {}}
        extraParams={extraParams}
      />
    );
  }

  if (item.endpoint) {
    return (
      <ApiAutocompleteByEndpoint
        id={field.name}
        endpoint={item.endpoint}
        onChange={field.onChange}
        multiple={multiple}
        size="small"
        inputRef={field.ref}
        value={value}
        disabled={readonly}
        sx={readonly ? disabledStyles : {}}
        extraParams={extraParams}
      />
    );
  }

  if (!!item.options?.length) {
    return (
      <AutocompleteByOptions
        id={field.name}
        onChange={field.onChange}
        options={item.options}
        multiple={multiple}
        size="small"
        inputRef={field.ref}
        value={value}
        disabled={readonly}
        sx={readonly ? disabledStyles : {}}
      />
    );
  }

  return <>unknown selector type</>;
};

export default memo(AutocompleteFactory);
